export const GretaAIChatFeedContentMode = {
  EmptyChat: 'emptyChat',
  Greeting: 'greeting',
  None: 'none',
  Skeleton: 'skeleton',
  Turns: 'turns',
}

// Window in which a scroll event may still be an echo of our own move.
export const GRETA_PROGRAMMATIC_SCROLL_MS = 100

export const GRETA_SCROLL_BOTTOM_THRESHOLD = 24

// Distance from the top that pulls the next older page of history.
export const GRETA_SCROLL_TOP_THRESHOLD = 120

// How long a just-opened feed is held at the bottom while its content settles.
export const GRETA_SETTLE_PIN_MS = 1000

// Gap above an anchored turn — matches the feed's top padding.
export const GRETA_TURN_ANCHOR_TOP_OFFSET = 16

export const QA_NAME_GRETA_AI_CHAT_MESSAGE_LIST = 'gretaAIChatMessageList'
